
import { Tabs } from 'ant-design-vue';
import {
  computed, defineComponent, PropType, SetupContext,
} from 'vue';

export default defineComponent({
  components: {
    aTabs: Tabs,
    aTabPane: Tabs.TabPane,
  },
  props: {
    title: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  setup(props, context: SetupContext) {
    const multiple = computed(() => {
      if (props.title.length === 1) return false;
      return true;
    });
    const changeActive = (key: string) => {
      context.emit('tab-change', key);
    };
    return {
      multiple,
      changeActive,
    };
  },
});
